import React from "react";
import NewMemberForm from "../NewMemberForm";

function MemberFormStep({ memberData, siteData, onSubmit }) {
  return (
    <div>
      <NewMemberForm
        memberData={memberData}
        siteData={siteData}
        handleMemberDataSubmit={onSubmit}
      />
    </div>
  );
}

export default MemberFormStep;
